






import { defineComponent, watch, toRef } from '@vue/composition-api';
import BootstrapModal from '@/components/UI/BootstrapModal.vue';

type PropsInterface = {
    title: string;
    isOpened: boolean;
};

export default defineComponent({
    name: 'HtmlModal',
    components: { BootstrapModal },
    props: {
        title: { type: String, required: false },
        isOpened: { type: Boolean, required: true },
        html: { type: String, required: false }
    },
    setup (props: PropsInterface, { root, refs }) {
        const isOpened = toRef(props, 'isOpened');
        watch(isOpened, value => {
            root.$nextTick(() => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                const $modal = $(refs.modal.$el);
                if (value) {
                    $modal.modal('show');
                } else {
                    $modal.modal('hide');
                }
            });
        });
    }
});
